<h1>
  <my-global-icon iconName="history" aria-hidden="true"></my-global-icon>
  <ng-container i18n>My watch history</ng-container>
  <span *ngIf="pagination.totalItems" class="pt-badge badge-secondary">{{ pagination.totalItems }}</span>
</h1>

<div class="top-buttons">
  <div class="search-wrapper">
    <my-advanced-input-filter [emitOnInit]="false" (search)="onSearch($event)"></my-advanced-input-filter>
  </div>

  <div class="history-switch">
    <my-input-switch inputName="track-watch-history" [(ngModel)]="videosHistoryEnabled" (ngModelChange)="onVideosHistoryChange()"></my-input-switch>
    <label for="track-watch-history" i18n>Track watch history</label>
  </div>

  <button class="delete-history" (click)="clearAllHistory()" i18n>
    <my-global-icon iconName="delete" aria-hidden="true"></my-global-icon>
    Clear all history
  </button>
</div>

<my-videos-selection
  [pagination]="pagination"
  [(videosModel)]="videos"
  [miniatureDisplayOptions]="miniatureDisplayOptions"
  [titlePage]="titlePage"
  [getVideosObservableFunction]="getVideosObservableFunction"
  [user]="user"
  [noResultMessage]="getNoResultMessage()"
  [enableSelection]="false"
  [disabled]="disabled"
  #videosSelection
>
  <ng-template ptTemplate="rowButtons" let-video>
    <div class="action-button">
      <my-delete-button i18n-label label="Delete from history" (click)="deleteHistoryElement(video)"></my-delete-button>
    </div>
  </ng-template>
</my-videos-selection>
